export const DEFAULT_DOMAIN = 'algoritmika.org'

// crm codes

export const CRM_PIPELINE_PYTSTART = 'pipeline__coding'
export const CRM_STATUS_PYTSTART = 'status__coding_newdeal'
export const CRM_TAGS_PYTSTART = 'Python Start'

export const CRM_PIPELINE_PYTPRO = 'pipeline__coding'
export const CRM_STATUS_PYTPRO = 'status__coding_newdeal'
export const CRM_TAGS_PYTPRO = 'Python Pro'

export const CRM_PIPELINE_CREATIVE = 'pipeline__coding'
export const CRM_STATUS_CREATIVE = 'status__coding_newdeal'
export const CRM_TAGS_CREATIVE = 'Scratch'

export const CRM_PIPELINE_PC = 'pipeline__coding'
export const CRM_STATUS_PC = 'status__coding_newdeal'
export const CRM_TAGS_PC = 'Digital Literacy'

export const CRM_PIPELINE_JUNIOR = 'pipeline__coding'
export const CRM_STATUS_JUNIOR = 'status__coding_newdeal'
export const CRM_TAGS_JUNIOR = 'Scratch Junior'

export const CRM_PIPELINE_GAMEDESIGN = 'pipeline__coding'
export const CRM_STATUS_GAMEDESIGN = 'status__coding_newdeal'
export const CRM_TAGS_GAMEDESIGN = 'Game Design'

export const CRM_PIPELINE_VIDEOCONTENT = 'pipeline__coding'
export const CRM_STATUS_VIDEOCONTENT = 'status__coding_newdeal'
export const CRM_TAGS_VIDEOCONTENT = 'Video content'

export const CRM_PIPELINE_WEBSITES = 'pipeline__coding'
export const CRM_STATUS_WEBSITES = 'status__coding_newdeal'
export const CRM_TAGS_WEBSITES = 'Websites'

export const CRM_PIPELINE_GRAPHICDESIGN = 'pipeline__coding'
export const CRM_STATUS_GRAPHICDESIGN = 'status__coding_newdeal'
export const CRM_TAGS_GRAPHICDESIGN = 'Graphic design'

export const CRM_PIPELINE_UNITY = 'pipeline__coding'
export const CRM_STATUS_UNITY = 'status__coding_newdeal'
export const CRM_TAGS_UNITY = 'Unity'

export const CRM_PIPELINE_PARTNER = 'pipeline__coding'
export const CRM_STATUS_PARTNER = 'status__coding_newdeal'
export const CRM_TAGS_PARTNER = 'Partner'

export const CRM_PIPELINE_CAMP = 'pipeline__coding'
export const CRM_STATUS_CAMP = 'status__coding_newdeal'
export const CRM_TAGS_CAMP = 'Camp'
